/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Rules_SummaryInputs */

const en_directory_vibebids_rules_summary = /** @type {(inputs: Directory_Vibebids_Rules_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rank is the bid. The board is public. The next founder can always take your place.`)
};

const zh_directory_vibebids_rules_summary = /** @type {(inputs: Directory_Vibebids_Rules_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排名就是出价。榜单公开可见，下一位创始人随时可以超过你。`)
};

/**
* | output |
* | --- |
* | "Rank is the bid. The board is public. The next founder can always take your place." |
*
* @param {Directory_Vibebids_Rules_SummaryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_rules_summary = /** @type {((inputs?: Directory_Vibebids_Rules_SummaryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Rules_SummaryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_rules_summary(inputs)
	return zh_directory_vibebids_rules_summary(inputs)
});
export { directory_vibebids_rules_summary as "directory.vibebids.rules_summary" }